import { queries } from "lib/build/dashboards/basic-health/queries";
import { Status } from "lib/build/forms/basic-health/patientCondition";

import { useFormatMessageMap } from "src/common/hooks/useFormatMessageMap";
import { useLastEventValueByQuery } from "src/features/events";
import { longStatusMessages } from "src/modules/basic-health/messages";

export function useLongStatus(): string | undefined {
	const formatMessage = useFormatMessageMap();
	const status =
		useLastEventValueByQuery<Status>(queries.patientStatus) || Status.NEW;
	return formatMessage(longStatusMessages, status);
}
